import React, { useRef, useState } from "react";
import styles from "./Header.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import CustomButton from "../ui/CustomButton/CustomButton";
import useAppSelector from "../../hooks/useAppSelector";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import LanguageSelect from "../shared/LanguageSelect/LanguageSelect";
import { useTranslation } from "react-i18next";
import ProfileSelect from "../ProfileSelect/ProfileSelect";
import logo from "../../assets/images/logo.svg";
import { environment } from "../../environment";
import languageIcon from "../../assets/images/icons/language.svg";
import selectArrow from "../../assets/images/icons/select-arrow.svg";
import { getLanguageFromLocal } from "../../helper/language";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const linksSelectRef = useRef<HTMLDivElement>(null);
  const { isAuthorized } = useAppSelector((state) => state.userProfileSlice);

  // const [isLinkSelectOpen, setIsLinkSelectOpen] = useState<boolean>(false);

  const handleOnLogin = () => {
    navigate("/login");
  };

  const handleOnRegister = () => {
    navigate("/register");
  };

  const handleOnGetStarted = () => {
    navigate("/your-location");
  };

  const renderLinksSelect = () => {
    return (
      <div ref={linksSelectRef} className={styles["links-select"]}>
        <div className={styles["main"]}>
          <div>
            <span className={styles["text"]}>{t("ForBusinesses")}</span>
          </div>
          <img className={`${styles["arrow"]}`} src={selectArrow} alt={"arrow"} />
        </div>
        <div className={`${styles["dropdown"]}`}>
          <ul className={styles["list"]}>
            <li>
              <NavLink className={({ isActive }) => `${styles["link"]}`} to={"/list-your-business"}>
                {t("ListYourBusiness")}
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => `${styles.link}`} to={"/free-listing"}>
                {t("FreeListing")}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className="container">
          <div className={styles.row}>
            <div className={styles.left}>
              <div className={styles.logo}>
                <img
                  onClick={() => {
                    navigate("/");
                  }}
                  src={logo}
                  alt={"logo"}
                />
              </div>
              <div className={styles.language}>
                <LanguageSelect />
              </div>
            </div>
            <div className={styles.burger}>
              <BurgerMenu />
            </div>

            <nav className={styles.nav}>
              <ul className={styles.menu}>
                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/"}
                  >
                    {t("Home")}
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={({ isActive }) => `${styles["link"]}`}
                    to={"/list-your-business"}
                  >
                    {t("ListYourBusiness")}
                  </NavLink>
                </li>

                {/*{renderLinksSelect()}*/}

                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/plans-and-credits"}
                  >
                    {t("PlansAndCredits")}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/gyms-location"}
                  >
                    {t("ClassesAndBookings")}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/corporate-wellness"}
                  >
                    {t("Corporate")}
                  </NavLink>
                </li>
              </ul>
            </nav>
            <div className={styles.box}></div>
            {!isAuthorized && (
              <div className={styles.btns}>
                <CustomButton
                  text={t("PreRegister")}
                  type={"button"}
                  typeStyle={"fill"}
                  functionOnClick={() => handleOnRegister()}
                />
              </div>
            )}
            {/*{environment.environment === "development" && (*/}
            {/*  <>*/}
            {/*    {!isAuthorized ? (*/}
            {/*      <div className={styles.btns}>*/}
            {/*        <CustomButton*/}
            {/*          text={t("Login")}*/}
            {/*          type={"button"}*/}
            {/*          typeStyle={"outline"}*/}
            {/*          functionOnClick={() => handleOnLogin()}*/}
            {/*        />*/}
            {/*        <CustomButton*/}
            {/*          text={t("GetStarted")}*/}
            {/*          type={"button"}*/}
            {/*          typeStyle={"fill"}*/}
            {/*          functionOnClick={() => handleOnGetStarted()}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    ) : (*/}
            {/*      <ProfileSelect />*/}
            {/*    )}*/}
            {/*  </>*/}
            {/*)}*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
